<template>
  <div>
    <v-autocomplete
      v-model="idEstado"
      :items="items"
      item-text="estado"
      item-value="idEstado"
      :label="requerido ? 'Estado *' : 'Estado'"
      outlined
      dense
      :required="requerido"
      :hide-details="!requerido"
      :loading="loading"
      :disabled="disabled"
      :readonly="consulta"
      :rules="[(v) => requerido ? !!v || 'Campo obligatorio' : true]"
      @change="selectEstado"  
    ></v-autocomplete>
   
    <v-snackbar
      key="snackbarSelectEstado"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false;">
        Cerrar
      </v-btn>
    </v-snackbar> 
  </div>
</template>

<script>
 import { getEstados } from "@/api";
        

export default {
  name: 'SelectEstado',
  components: {},
  props: {
    idEstadoProp: {
      type: Number,
      default: null
    },
    fnChange: {
      type: Function,
      default: () => {}
    },
    requerido: {
      type: Boolean,
      default: false
    },
    consulta: {
      type: Boolean,
      default: false
    } 
  },
  data: () => ({
    snackbar: false,
    snackbarColor: '',
    snackbarTexto: '',
    loading: false,
    disabled: false,
    idEstado: null,
    items: [],
  }),
  computed: {
  },
  watch: {
    idEstadoProp: {
			handler (newValue, oldValue) {
        this.idEstado = newValue;
        this.selectEstado();
			},
		},
  },
  beforeMount() {

  },
  mounted() {
    this.idEstado = this.idEstadoProp;
    this.cargarEstados();
  },
  methods: {
    async cargarEstados () {
      var self = this;

      self.loading = true;
      self.disabled = true;
      self.items = [];
      self.snackbar = false;
      self.snackbarColor = '';
      self.snackbarTexto = '';

      try {
        let response = await getEstados();

        if (response.status === 200) {        
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              if(response.data.data.length > 0){
                self.items.push({idEstado: null, estado: "Seleccione una opción"});
                Array.prototype.push.apply(self.items, response.data.data)
              }
              self.disabled = false;
             }
            else{
              self.snackbarColor = 'error';
              self.snackbarTexto = response.data.message;
              self.snackbar = true;
            }
          } else {
            self.snackbarColor = 'error';
            self.snackbarTexto = response.data.message;
            self.snackbar = true;
          } 
        } else {
          self.snackbarColor = 'error';
          self.snackbarTexto = 'Error de red';
          self.snackbar = false;
        }
        self.loading = false;
      } catch (e) {        
        self.snackbarColor = 'error';
        self.snackbarTexto = e;
        self.snackbar = true;
        self.loading = false;
      }
    },
    selectEstado(){
      if(this.idEstado == null){
        this.fnChange({idEstado:null, estado: null});
      }
      else{
        var objEstado = this.items.filter(n=>n.idEstado == this.idEstado)[0];
        this.fnChange(objEstado);
      }
    }
  },
};
</script>